import { FaChevronDown } from 'react-icons/fa';
export default FaChevronDown;

//# sourceMappingURL=ArrowDown.js.map